/**
 * Главный сервис для работы с аналитикой. Регистрирование всех событий нужно делать
 * через него и в нём уже уточнять формат передачи события конкретным трекерам.
 */
class Analytics {
    constructor (locator) {
        this._window = locator.resolve('window');
        this._locator = locator;
    }

    /**
     * Регистрирование события аналитики.
     *
     * @param {Object} data
     * @param {*} args
     */
    event (data = {}, ...args) {
        const role = data.role;

        if (!role || role === 'client' || role === 'unauthorized') {
            this._locator.resolve('ga').event(data, args);
            this._locator.resolve('ya').event(data, args);
        }
    }

    /**
     * Регистрация факта показа страницы.
     *
     * Данное событие отправляется во все трекеры.
     *
     * @param {Object} data
     */
    pageview (data = {}) {
        const location = data.location || this._window.location.href;
        const page = data.page || this._window.location.pathname;
        const title = data.title || this._window.document.title;
        const role = data.role;

        if (!role || role === 'client' || role === 'unauthorized') {
            this._locator.resolve('ga').pageview({ location, page, title });
            this._locator.resolve('ya').pageview(page, { title });
        }
    }
}

module.exports = Analytics;



// WEBPACK FOOTER //
// ./services/analytics/analytics.js